import Controller, { inject as controller } from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';

const COLUMN_PROPERTIES = {
  CURRENCY_CODE: 'currencyCode',
  REFERENCE_CURRENCY: 'referenceCurrency',
  EXCHANGE_RATE: 'exchangeRate',
};

export default class MarketRevenueInsightCurrencyTableController extends Controller {
  @service('hotel-and-market') hotelAndMarketService;
  @service intl;
  @service riSelections;
  @service simpleExport;

  // Parent controller
  @controller('market.revenue-insight') multi;

  get columns() {
    return [
      {
        name: this.intl.t('general.currency_code'),
        valuePath: COLUMN_PROPERTIES.CURRENCY_CODE,
        textAlign: 'left',
      },
      {
        name: this.intl.t('general.reference_currency'),
        valuePath: COLUMN_PROPERTIES.REFERENCE_CURRENCY,
        textAlign: 'left',
      },
      {
        name: this.intl.t('general.exchange_rate'),
        valuePath: COLUMN_PROPERTIES.EXCHANGE_RATE,
        textAlign: 'left',
      },
    ];
  }

  get currencies() {
    return this.currenciesTask.last?.value ?? [];
  }

  get currenciesTask() {
    return this.multi.model.currenciesTask;
  }

  get isLoading() {
    return this.currenciesTask.isRunning;
  }

  get rows() {
    return this.currencies.map((currency) => {
      const exchangeRateNumber = this.intl.formatNumber(
        currency.referenceValue,
        {
          minimumFractionDigits: 0,
          maximumFractionDigits: 5,
        },
      );

      return {
        [COLUMN_PROPERTIES.CURRENCY_CODE]: currency.code,
        [COLUMN_PROPERTIES.REFERENCE_CURRENCY]: `1 ${this.riSelections.riCurrency}`,
        [COLUMN_PROPERTIES.EXCHANGE_RATE]: `${exchangeRateNumber} ${currency.code}`,
      };
    });
  }

  @action
  exportCurrencyTable() {
    const marketId = this.hotelAndMarketService.market.id;

    const sheetName = this.intl.t('general.currency');

    const headers = this.columns.map((column) => column.name);

    const content = this.rows.map((row) => [
      row[COLUMN_PROPERTIES.CURRENCY_CODE],
      row[COLUMN_PROPERTIES.REFERENCE_CURRENCY],
      row[COLUMN_PROPERTIES.EXCHANGE_RATE],
    ]);

    const postData = JSON.stringify({ headers, content, sheetName });
    this.simpleExport.execute(postData, marketId, false);
  }
}
